export default __webpack_public_path__ + "static/logo-prestashop-white-1a67972a939f7b5bddf021e6ad62e9dd.svg";